<div>
  <app-cue-table *ngIf="reqtableConfigs" [dataset]="reqtableDatasource" [gridOptions]="reqtableConfigs"
    [columnDefinitions]="reqtableColumnConfigs" [callback]="gridCallBacks"></app-cue-table>
</div>

<div class="footer rej_req pop_footer">
  <span class="align-right col-md-6 secondory_btn">
    <button class="btn btn-primary" (click)="onClose()">Close</button>
  </span>
</div>
